<template>
  <div class="navbar">
    <div class="navtext" @click="$_handlerClickJump('/')">
      <P>杭州图景网络技术有限公司</P>
    </div>
    <ul class="ul">
      <li class="li" v-for="(item, index) in list" :key="index" @click="$_handlerClickJump(item, index)" :class="isCheckFn(item) ? 'checked' : ''">
        <div class="li-text">
          {{ item.name }}
        </div>
      </li>
    </ul>
    <div class="auth-action" @click="handleAuthClick">
      {{ isLogin ? '退出' : '登录' }}
    </div>
    <button class="menu-toggle" type="button" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <div class="mobile-menu" :class="{ open: isMenuOpen }">
      <div
        class="mobile-item"
        v-for="(item, index) in list"
        :key="'mobile-' + index"
        :class="{ checked: isCheckFn(item) }"
        @click="handleMobileJump(item)"
      >
        {{ item.name }}
      </div>
      <div class="mobile-auth" @click="handleMobileAuthClick">
        {{ isLogin ? '退出' : '登录' }}
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';

export default {
  name: 'navbar',
  data() {
    return {
      num: '',
      type: false,
      index: 0,
      checkIndex: 0,
      isMenuOpen: false,
      list: [
        {
          name: '首页',
          route: '/'
        },
        {
          name: '地图能力',
          route: '/ability'
        },
        {
          name: '解决方案',
          route: '/solve',
          chirld: 'city'
        },
        {
          name: '客户案例',
          route: '/case'
        },
        {
          name: '关于我们',
          route: '/about'
        }
      ]
    };
  },
  computed: {
    route() {
      return this.$route.path;
    },
    isLogin() {
      return !!getToken();
    }
  },
  watch: {
    '$route.fullPath'() {
      this.isMenuOpen = false;
    }
  },
  methods: {
    safePush(path) {
      if (this.$route.fullPath === path || this.$route.path === path) {
        return;
      }
      this.$router.push({ path }).catch(err => {
        if (!err || err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    // 跳转路由
    $_handlerClickJump(item, index) {
      const route = typeof item === 'string' ? item : item.route;
      if (!route) {
        return;
      }
      if (route !== '/' && this.$route.path.indexOf(route) === 0) {
        return;
      }
      this.safePush(route);
      document.documentElement.scrollTop = 0;
    },
    handleMobileJump(item) {
      this.isMenuOpen = false;
      this.$_handlerClickJump(item);
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    // 判断路由是否被选中
    isCheckFn(item) {
      // const {
      //   path,
      //   meta: { title }
      // } = this.$route;
      const { path } = this.$route;
      const { name, route } = item;
      // 判断首页
      if (path === route) {
        return true;
      }
      return path.includes(route) && name !== '首页';
    },
    async handleAuthClick() {
      if (this.isLogin) {
        await this.$store.dispatch('userLogout');
        if (this.$route.path !== '/') {
          this.safePush('/');
        }
        return;
      }
      this.$router.push({
        path: '/login',
        query: {
          redirect: this.$route.fullPath
        }
      }).catch(err => {
        if (!err || err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    handleMobileAuthClick() {
      this.isMenuOpen = false;
      this.handleAuthClick();
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.navbar {
  position: fixed;
  top: 0;
  width: 100vw;
  /* min-width: 1226px; */
  height: 52px;
  background-color: #282828;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-family: 'PingFang';
  z-index: 100;
  padding: 0 32px;
  box-sizing: border-box;
  .menu-toggle {
    display: none;
    width: 40px;
    height: 40px;
    padding: 0;
    background: transparent;
    border: 0;
    cursor: pointer;
    span {
      display: block;
      width: 22px;
      height: 2px;
      margin: 4px auto;
      background: #e5e5e5;
      transition: 0.2s;
    }
  }
  .mobile-menu {
    position: absolute;
    top: calc(100% + 8px);
    right: 16px;
    width: calc(100vw - 32px);
    max-width: 220px;
    padding: 10px 0;
    background: rgba(40, 40, 40, 0.97);
    border: 1px solid rgba(229, 229, 229, 0.14);
    border-radius: 14px;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.22);
    opacity: 0;
    pointer-events: none;
    transform: translateY(-8px);
    transition: 0.2s ease;
  }
  .mobile-menu.open {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }
  .mobile-item,
  .mobile-auth {
    padding: 12px 18px;
    color: #e5e5e5;
    font-size: 14px;
    line-height: 1.4;
    cursor: pointer;
    transition: 0.2s;
  }
  .mobile-item:hover,
  .mobile-auth:hover,
  .mobile-item.checked {
    color: #f15030;
    background: rgba(241, 80, 48, 0.08);
  }
  .navtext {
    height: 100%;
    display: flex;
    align-items: center;
    p {
      font-size: 22px;
      color: #e5e5e5;
      cursor: pointer;
    }
  }
  .ul {
    height: 100%;
    display: flex;
    .li {
      cursor: pointer;
      position: relative;
      padding: 0 10px;
      font-size: 16px;
      color: #e5e5e5;
      line-height: 50px;
      margin: 0 10px;
      letter-spacing: 1px;
      &:hover {
        &::before {
          width: 100%;
        }
        .li-text {
          color: #f15030;
        }
      }
      &::before {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        height: 3px;
        background: #f15030;
        width: 0;
        transition: 0.3s linear;
        transform: translateX(-50%);
      }
    }
    .checked {
      .li-text {
        color: #f15030;
      }
      &::before {
        width: 100%;
      }
    }
  }
  .auth-action {
    min-width: 52px;
    height: 30px;
    padding: 0 14px;
    color: #e5e5e5;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    border: 1px solid rgba(229, 229, 229, 0.35);
    border-radius: 15px;
    cursor: pointer;
    transition: 0.2s;
    &:hover {
      color: #f15030;
      border-color: #f15030;
    }
  }
}

@media (max-width: 900px) {
  .navbar {
    justify-content: space-between;
    padding: 0 16px;
  }

  .navbar .navtext p {
    font-size: 16px;
  }

  .navbar .ul,
  .navbar .auth-action {
    display: none;
  }

  .navbar .menu-toggle {
    display: block;
  }
}
</style>
